import React, { Component } from "react";
import CreateInvoice from './CreateInvoice';
import invoiceService from '../../services/WebInvoiceService';
import InvoiceForm from './InvoiceForm';

export default class CreateTowInvoice extends Component {
    constructor(props) {        
        super(props);        
        const { customerId } = props.match.params;
        this.state = {
            initialState: this.createInitialState(customerId)
        };
    }
    
    createInitialState(customerId) {
        const invoice = {
            customerId: customerId,
            paymentType: null,
            mileageCharges: '',
            timeCharges: '',
            additionalCharges: '',
            credits: '',
            hub: '',
            invoiceTotal: '',
            location: '',
            unit: '',
            vehicle: '',
            towDriver: '',
            towVehicle: '',
            serviceNotes: '',
            companyPO: '',
            postedToReceivables: '',
            referenceNumber: '',
            paymentDate: null,
            dateTowed: null
        };
        
        return invoice;
    }

    handleGenerateClick =  async (invoice) => {
        await invoiceService.createInvoiceSync(invoice);
        this.props.history.push({pathname:`/customer/${invoice.customerId}/invoices`});
    }

    render() {        
        return (<CreateInvoice initialState={this.state.initialState} handleGenerateClick={this.handleGenerateClick} form={InvoiceForm}/>)
    }    
}